import { TextInput } from '@pandiafi/design-system'
import { Field, FieldProps } from 'formik'
import { t } from 'i18next'
import React from 'react'

import FormFieldWrapper from 'components/FormField'

type Props = {
  required: boolean
}

export const StreetAddressField: React.FC<Props> = ({ required }) => {
  return (
    <Field name="newAddress.streetAddress">
      {({ field, meta }: FieldProps) => (
        <FormFieldWrapper
          name={field.name}
          label={t('terminateContract:labels.streetAddress')}
          className="min-tablet:flex-1"
          meta={meta}
          labelBold
          required={required}
        >
          <TextInput {...field} />
        </FormFieldWrapper>
      )}
    </Field>
  )
}
